/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActivityItem } from './ActivityItem';
import {
    ActivityItemFromJSON,
    ActivityItemFromJSONTyped,
    ActivityItemToJSON,
    ActivityItemToJSONTyped,
} from './ActivityItem';

/**
 * 
 * @export
 * @interface RecentActivityWidgetData
 */
export interface RecentActivityWidgetData {
    /**
     * 
     * @type {Array<ActivityItem>}
     * @memberof RecentActivityWidgetData
     */
    items: Array<ActivityItem>;
}

/**
 * Check if a given object implements the RecentActivityWidgetData interface.
 */
export function instanceOfRecentActivityWidgetData(value: object): value is RecentActivityWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function RecentActivityWidgetDataFromJSON(json: any): RecentActivityWidgetData {
    return RecentActivityWidgetDataFromJSONTyped(json, false);
}

export function RecentActivityWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentActivityWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ActivityItemFromJSON)),
    };
}

export function RecentActivityWidgetDataToJSON(json: any): RecentActivityWidgetData {
    return RecentActivityWidgetDataToJSONTyped(json, false);
}

export function RecentActivityWidgetDataToJSONTyped(value?: RecentActivityWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ActivityItemToJSON)),
    };
}

